import enLocale from 'date-fns/locale/en-US'
import deLocale from 'date-fns/locale/de'
import frLocale from 'date-fns/locale/fr'
import itLocale from 'date-fns/locale/it'

/**
 * Retrieves the DateFns locale object based on the provided locale code.
 *
 * @param {string | undefined | null} localeCode - The locale code (e.g., 'de', 'fr', 'en').
 * @returns {Locale | undefined} The DateFns locale object corresponding to the provided code, or undefined if not found.
 */
export const getDateFnsLocale = (localeCode: string | undefined | null): Locale | undefined => {
  switch (localeCode) {
    case 'de':
      return deLocale
    case 'fr':
      return frLocale
    case 'en':
      return enLocale
    case 'it':
      return itLocale
    default:
      return deLocale
  }
}
